export default "/images/kyc_penetration_testing/kyc_penetration_testing__heading_icon.png";